import MapComponent from '@Core/components/map';
import NotificationBanner from '@Core/components/notificationBanner';
import LocationCard from './location';
import Filters from './filters';

const locationCardsComponents = [LocationCard];

const mapComponents = [MapComponent, NotificationBanner];

const selectors = {
  locationCard: '[data-comp-location]',
  filter: '[data-comp-location-search-filter]',
  listingContainer: '[data-comp-location-search-listings]',
  map: '[data-comp-map]',
};

const classes = {
  hidden: 'hide',
};

const filterMapping = {
  department: Filters.DepartmentFilter,
  vehicleType: Filters.VehicleTypeFilter,
};

const listingFadeOutOptions = {
  duration: 300,
};

export default {
  classes,
  filterMapping,
  listingFadeOutOptions,
  locationCardsComponents,
  mapComponents,
  selectors,
};
